/* eslint-disable no-unused-vars */
import PCheck from "../../../components/pos/PCheck";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Button } from "@mui/material";
import Divider from "@mui/material/Divider";
import MUIDataTable from "mui-datatables";
import { StringUtils } from "../../../utils/StringUtils";

export default function ProductPricingLevelView(props) {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {}, []);

  useEffect(() => {
    if (props.tableMeta) {
      if (props.pricingLevelData.length == 0) {
        showProductPricingLevelView(props.tableMeta);
      }
      console.log(">>>", props.pricingLevelData);
    }
  }, [props.tableMeta]);

  function showProductPricingLevelView(tableMeta) {
    let pricingLevelDataList = [];

    let pricingLevel = [...tableMeta.tableData[tableMeta.rowIndex][14]];
    console.log(">>", tableMeta.tableData[tableMeta.rowIndex]);
    for (let i = 0; i < pricingLevel.length; i++) {
      if (i < tableMeta.tableData[tableMeta.rowIndex][13].length) {
        let rowData = tableMeta.tableData[tableMeta.rowIndex][13][i];
        pricingLevelDataList.push({
          level: pricingLevel[i].name,
          unitType: tableMeta.tableData[tableMeta.rowIndex][0]?.v?.name
            ? tableMeta.tableData[tableMeta.rowIndex][0].v.name
            : "",
          cost: rowData.cost,
          margin: rowData.margin,
          marginPercentage: rowData.marginPer,
          priceWithoutTax: rowData.price,
          isSelected: true,
        });
      } else {
        pricingLevelDataList.push({
          level: pricingLevel[i].name,
          unitType: tableMeta.tableData[tableMeta.rowIndex][0]?.v?.name
            ? tableMeta.tableData[tableMeta.rowIndex][0].v.name
            : "",
          cost: 0,
          margin: 0,
          marginPercentage: 0,
          priceWithoutTax: 0,
          isSelected: false,
        });
      }
    }
    props.setPricingLevelData(pricingLevelDataList);
  }

  async function onSave() {
    let pricingLevelList = [];
    props.pricingLevelData.map((item) => {
      if (item.isSelected) {
        let saveObject = Object.create(null);
        saveObject.cost = item.cost;
        saveObject.marginPer = item.marginPercentage;
        saveObject.margin = item.margin;
        saveObject.price = item.priceWithoutTax;
        pricingLevelList.push(saveObject);
      }
    });
    let tempPricingData = [...props.tableMeta.tableData];
    tempPricingData[props.tableMeta.rowIndex][13] = pricingLevelList;
    props.setPricingData(tempPricingData);
    props.showMessage("success", translate("Saved sucessfully"));
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 300,
  };

  function changeAllSelection(value) {
    let pricingLevelDataTemp = [...props.pricingLevelData];
    for (let i = 0; i < pricingLevelDataTemp.length; i++) {
      pricingLevelDataTemp[i].isSelected = value;
    }
    props.setPricingLevelData(pricingLevelDataTemp);
    props.setIsAllSelected(value);
  }

  function checkAllSelected() {
    let isAllSelected = true;
    let pricingLevelDataTemp = [...props.pricingLevelData];
    if (pricingLevelDataTemp.length == 0) {
      props.setIsAllSelected(false);
      return;
    }
    for (let i = 0; i < pricingLevelDataTemp.length; i++) {
      if (!pricingLevelDataTemp[i].isSelected) {
        isAllSelected = false;
        break;
      }
    }
    props.setIsAllSelected(isAllSelected);
  }

  function updatePricing(rowIndex, changeType, value) {
    let tempPricingLevels = [...props.pricingLevelData];
    if (changeType == "COST") {
      tempPricingLevels[rowIndex].cost = value;
      if (tempPricingLevels[rowIndex].priceWithoutTax) {
        if (
          tempPricingLevels[rowIndex].priceWithoutTax &&
          tempPricingLevels[rowIndex].priceWithoutTax > 0 &&
          tempPricingLevels[rowIndex].cost &&
          tempPricingLevels[rowIndex].cost > 0
        ) {
          tempPricingLevels[rowIndex].margin =
            tempPricingLevels[rowIndex].priceWithoutTax -
            tempPricingLevels[rowIndex].cost;
          tempPricingLevels[rowIndex].marginPercentage =
            (tempPricingLevels[rowIndex].margin /
              tempPricingLevels[rowIndex].cost) *
            100;
        } else {
          tempPricingLevels[rowIndex].margin = 0;
          tempPricingLevels[rowIndex].marginPercentage = 0;
        }
      }
    } else if (changeType == "MARGIN") {
      tempPricingLevels[rowIndex].margin = value;
      if (
        tempPricingLevels[rowIndex].cost &&
        tempPricingLevels[rowIndex].cost > 0
      ) {
        tempPricingLevels[rowIndex].marginPercentage =
          (parseFloat(tempPricingLevels[rowIndex].margin) /
            parseFloat(tempPricingLevels[rowIndex].cost)) *
          100;
        tempPricingLevels[rowIndex].priceWithoutTax =
          parseFloat(tempPricingLevels[rowIndex].cost) +
          parseFloat(tempPricingLevels[rowIndex].margin);
      }
    } else if (changeType == "MARGIN_PER") {
      tempPricingLevels[rowIndex].marginPercentage = value;
      if (
        tempPricingLevels[rowIndex].cost &&
        tempPricingLevels[rowIndex].cost > 0
      ) {
        tempPricingLevels[rowIndex].margin =
          parseFloat(tempPricingLevels[rowIndex].cost) *
          (tempPricingLevels[rowIndex].marginPercentage / 100);
        tempPricingLevels[rowIndex].priceWithoutTax =
          parseFloat(tempPricingLevels[rowIndex].cost) +
          tempPricingLevels[rowIndex].margin;
      }
    } else if (changeType == "PRICE") {
      tempPricingLevels[rowIndex].priceWithoutTax = value;
      if (
        tempPricingLevels[rowIndex].cost &&
        tempPricingLevels[rowIndex].cost > 0 &&
        tempPricingLevels[rowIndex].priceWithoutTax &&
        tempPricingLevels[rowIndex].priceWithoutTax > 0
      ) {
        tempPricingLevels[rowIndex].margin =
          tempPricingLevels[rowIndex].priceWithoutTax -
          tempPricingLevels[rowIndex].cost;
        tempPricingLevels[rowIndex].marginPercentage =
          (tempPricingLevels[rowIndex].margin /
            tempPricingLevels[rowIndex].cost) *
          100;
      } else {
        tempPricingLevels[rowIndex].margin = 0;
        tempPricingLevels[rowIndex].marginPercentage = 0;
      }
    }
    tempPricingLevels[rowIndex].marginPercentage =
      StringUtils.formattedNumberWithStoreDecimal(
        tempPricingLevels[rowIndex].marginPercentage,
        props.context
      );
    props.setPricingLevelData(tempPricingLevels);
  }

  const columns = [
    {
      name: "level",
      label: translate("Level"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "unitType",
      label: translate("Unit Type"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "cost",
      label: translate("Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                updatePricing(tableMeta.rowIndex, "COST", e.target.value);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "margin",
      label: translate("Margin"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                updatePricing(tableMeta.rowIndex, "MARGIN", e.target.value);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "marginPercentage",
      label: translate("Margin %"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                updatePricing(tableMeta.rowIndex, "MARGIN_PER", e.target.value);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "priceWithoutTax",
      label: translate("Price W/O Tax"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                updatePricing(tableMeta.rowIndex, "PRICE", e.target.value);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              <PCheck
                onChange={(value) => changeAllSelection(value)}
                checked={props.isAllSelected}
                label=""
              ></PCheck>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right" }}>
            <PCheck
              onChange={(value) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].isSelected = value;
                props.setPricingLevelData(tempData);
                checkAllSelected();
              }}
              checked={tableMeta.tableData[tableMeta.rowIndex].isSelected}
              label=""
            ></PCheck>
          </div>
        ),
      },
    },
  ];

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Divider style={{ marginBottom: "5px" }} />
          <MUIDataTable
            data={props.pricingLevelData}
            columns={columns}
            options={options}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: "95%",
            position: "absolute",
            bottom: 20,
          }}
        >
          <Divider />
          <table width="100%">
            <tbody>
              <tr>
                <td width="95%"></td>
                <td>
                  <Button
                    style={{ marginTop: "5px" }}
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );
}
